import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    border: "none",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    //  border: "2px solid #000",
    // boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
    outline: "none",
    border: "none",
    width: "390px",
    borderRadius: "10px",
  },
}));

export default function CahngePasswordModal({
  openModal,
  setOpenModal,
  currentPassword,
  newPassword,
  confirmPassword,
  setcurrentPassword,
  setnewPassword,
  setconfirmPassword,
  changepasswordhandler,
}) {
  const classes = useStyles();
  const [show, setShow] = useState({
    new: false,
    old: false,
    confirm: false,
  });
  const handleClose = () => {
    setcurrentPassword("");
    setconfirmPassword("");
    setnewPassword("");
    setOpenModal(false);
  };
  const handleShowPassword = (type) => {
    if (type === "old") {
      setShow({ ...show, old: !show.old });
    } else if (type === "new") {
      setShow({ ...show, new: !show.new });
    } else if (type === "confirm") {
      setShow({ ...show, confirm: !show.confirm });
    }
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <div className={classes.paper}>
            <div
              style={{
                background: "#907ea5",
                borderTopRightRadius: "10px",
                borderTopLeftRadius: "10px",
              }}
            >
              <Grid
                container
                direction="row"
                //alignItems="flex-start"
                justifyContent="space-between"
                spacing={1}
                item={12}
              >
                <Grid item={5}>
                  <h5
                    id="transition-modal-title"
                    style={{ marginLeft: "10px", marginTop: "10px" }}
                  >
                    Change Password
                  </h5>
                </Grid>
                <Grid item={3} justifyContent="flex-end">
                  <IconButton onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                item={12}
              >
                <Grid
                  item={12}
                  style={{
                    marginTop: "10px",
                    marginLeft: "10px",
                    width: "70%",
                  }}
                ></Grid>
                {/* <Grid item={12} style={{ marginLeft: "10px", width: "70%" }}>
                  <Typography>
                    <Typography>Enail</Typography>
                    <TextField
                      className="user"
                      id="datetime-local"
                      name="fromDate"
                      
                      value={JSON.parse(localStorage.getItem("data")).email}
                      //   margin="dense"
                      // value={fromDate}
            //  onChange={(e) => setUpdetefromDate(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                    />
                  </Typography>
                </Grid> */}

                {/* <Grid item={12} style={{ marginLeft: "10px", width: "70%" }}>
                  <Typography>
                    <Typography>Password</Typography>

                    <TextField
                      className="user"
                      id="datetime-local"
                      name="fromDate"
                      type="text"
                      value={JSON.parse(localStorage.getItem("data")).email}
                      //   margin="dense"
                      // value={fromDate}
                     // onChange={(e) => setUpdateTodate(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                    />
                  </Typography>
                </Grid> */}
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>Old Password</Typography>

                    <TextField
                      className="user"
                      id="datetime-local"
                      name="fromDate"
                      type={show.old ? "text" : "password"}
                      value={currentPassword}
                      //fullWidth
                      //   margin="dense"
                      // value={fromDate}
                      onChange={(e) => setcurrentPassword(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleShowPassword("old")}
                            >
                              {!show.old ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>New Password</Typography>

                    <TextField
                      className="user"
                      id="datetime-local"
                      name="fromDate"
                      type={show.new ? "text" : "password"}
                      value={newPassword}
                      onChange={(e) => setnewPassword(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleShowPassword("new")}
                            >
                              {!show.new ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid item={12} style={{ marginLeft: "10px", width: "90%" }}>
                  <Typography>
                    <Typography>Confirm Password</Typography>

                    <TextField
                      className="user"
                      id="datetime-local"
                      name="fromDate"
                      type={show.confirm ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setconfirmPassword(e.target.value)}
                      variant="outlined"
                      style={{ backgroundColor: "white" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleShowPassword("confirm")}
                            >
                              {!show.confirm ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Typography>
                </Grid>

                <Grid
                  item={3}
                  style={{
                    margin: "10px 10px",
                    position: "relative",
                    left: "68%",
                  }}
                >
                  <Typography>
                    <Button variant="contained" onClick={changepasswordhandler}>
                      Update
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
